import Analytics from '@web/services/Analytics/Analytics'

export type PlatformView = 'mobile_web' | 'desktop_web'
export type ModalType = 'continue_in_app' | 'setup_reminders'
export type CloseMethod = 'cross_button' | 'secondary_button'

export function postFirstDayModalShown (payload: { modalType: ModalType; platformView: PlatformView }): void {
  Analytics.send({ action: 'post_first_day_modal_shown', modal_type: payload.modalType, platform_view: payload.platformView })
}

export function postFirstDayModalCtaClicked (payload: { modalType: ModalType; platformView: PlatformView }): void {
  Analytics.send({ action: 'post_first_day_modal_cta_clicked', modal_type: payload.modalType, platform_view: payload.platformView })
}

export function postFirstDayModalClosed (payload: { modalType: ModalType; closeMethod: CloseMethod; platformView: PlatformView }): void {
  Analytics.send({ action: 'post_first_day_modal_closed', modal_type: payload.modalType, close_method: payload.closeMethod, platform_view: payload.platformView })
}

export function postFirstDayModalRedirectApp (): void {
  Analytics.send({ action: 'post_first_day_modal_redirect_app', platform_view: 'mobile_web' })
}

export function postFirstDayModalRedirectReminders (payload: { platformView: PlatformView }): void {
  Analytics.send({ action: 'post_first_day_modal_redirect_reminders', platform_view: payload.platformView })
}
